import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M15.297 6.794a.75.75 0 1 0-1.06-1.06L12.75 7.22V1.75a.75.75 0 0 0-1.5 0v5.47L9.763 5.734a.75.75 0 1 0-1.06 1.06l2.767 2.767a.75.75 0 0 0 1.06 0zM7.165 10.33a.75.75 0 0 1 1.006.335l.75 1.5a.75.75 0 1 1-1.342.67l-.75-1.5a.75.75 0 0 1 .336-1.006M9.691 16.047a5.25 5.25 0 0 1 7.54 4.267.75.75 0 0 0 1.495-.128 6.77 6.77 0 0 0-1.394-3.563 6.75 6.75 0 0 0-12.057 3.563.75.75 0 1 0 1.494.128 5.25 5.25 0 0 1 2.922-4.267M.75 22.25a.75.75 0 0 1 .75-.75h21a.75.75 0 0 1 0 1.5h-21a.75.75 0 0 1-.75-.75M2.586 15.58a.75.75 0 0 0-.671 1.34l1.5.75a.75.75 0 1 0 .67-1.34zM22.086 16.92a.75.75 0 1 0-.671-1.34l-1.5.75a.75.75 0 1 0 .67 1.34zM17.171 11.335a.75.75 0 1 0-1.342-.67l-.75 1.5a.75.75 0 0 0 1.342.67z" />
  </>
);

const Sunset = Icon('sunset', svgContents);

export default Sunset;
